module.exports = __webpack_public_path__ + "img/zsgg-2.4f282875.png";